import { render, staticRenderFns } from "./syncSubscribeWechat.vue?vue&type=template&id=15dcd65d&scoped=true"
import script from "./syncSubscribeWechat.vue?vue&type=script&lang=js"
export * from "./syncSubscribeWechat.vue?vue&type=script&lang=js"
import style0 from "./syncSubscribeWechat.vue?vue&type=style&index=0&id=15dcd65d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dcd65d",
  null
  
)

export default component.exports